import { Constants } from '@pwc/pwc-deals-web-common';
import { useSelector } from 'react-redux';
import featureFlags from 'common/helpers/featureFlags';
import authorizationService from '../services/security/authorizationService';
import {
  getProjectTerritory,
  customColourConversion,
} from '../../features/project/projectSlice';

export const isDSUrlvalid = () => {
  return (
    process.env.REACT_APP_DS_CREATE_URL &&
    process.env.REACT_APP_DS_CREATE_URL.length > 0
  );
};

export const isDSAppUrlvalid = () => {
  return (
    process.env.REACT_APP_DS_EDIT_URL &&
    process.env.REACT_APP_DS_EDIT_URL.length > 0
  );
};

export const isUSTerritory = process.env.REACT_APP_TERRITORY
  ? process.env.REACT_APP_TERRITORY === Constants.TERRITORY_CODES.UNITED_STATES
  : false;

export const isEUTerritory = process.env.REACT_APP_TERRITORY
  ? process.env.REACT_APP_TERRITORY === Constants.TERRITORY_CODES.UNITED_KINGDOM
  : false;

export const isCNTerritory = process.env.REACT_APP_TERRITORY
  ? process.env.REACT_APP_TERRITORY === Constants.TERRITORY_CODES.CHINA
  : false;

// eslint-disable-next-line no-nested-ternary
export const territoryConfigObjects = () => {
  if (isUSTerritory) {
    return Constants.TERRITORY_CONFIG_US;
  }
  if (isEUTerritory) {
    return Constants.TERRITORY_CONFIG_EU;
  }
  if (isCNTerritory) {
    return Constants.TERRITORY_CONFIG_CN;
  }
  return Constants.TERRITORY_CONFIG_AP;
};

export const defaultTerritory = territoryConfigObjects().find(
  (territory) => territory.isDefault === true
);

export const getTerritory = (territories, territoryCode) => {
  return territories.find(
    (territory) => territory.territoryCode === territoryCode
  );
};

export const getTandCterritory = () => {
  const jwtToken = authorizationService.getToken() || {};
  const { country: countryCode } = jwtToken;
  let countryCodeExists = false;

  if (featureFlags.isLegalStatementInCombineListEnabled) {
    countryCodeExists = Object.values(Constants.TERRITORY_CODES).some(
      (territory) => territory === countryCode
    );
  } else {
    countryCodeExists = territoryConfigObjects().some(
      (territory) => territory.territoryCode === countryCode
    );
  }

  const { territoryCode: defaultTerritoryCode } = defaultTerritory;
  const territoryCode = countryCodeExists ? countryCode : defaultTerritoryCode;
  return territoryCode;
};

export const useTerritoryConfig = () => {
  const projectTerritory = useSelector(getProjectTerritory);
  return territoryConfigObjects().find(
    (territory) => projectTerritory === territory.territoryCode
  );
};

export const useFeaturePerTerritoryConfig = (featureId, configIndex = 0) => {
  const territory = useTerritoryConfig();
  const featureConfig = territory?.features?.find(
    (feature) => feature.id === featureId
  );
  return featureConfig?.configurations[configIndex];
};

export const isCustomColourConversionActive = (contentColourConversion) =>
  contentColourConversion
    ? contentColourConversion.toLowerCase() ===
      customColourConversion.toLowerCase()
    : false;

export const isUSTerritoryProject = (projectTerritory) =>
  projectTerritory
    ? projectTerritory.toLowerCase() ===
      Constants.TERRITORY_CODES.UNITED_STATES.toLowerCase()
    : false;

// This function returns projects in the order -
// Demo projects followed by other projects and all are in desc order based on the creation date, we are using Id for creation date
// Purpose - 2 indicated demo projects
export const sortProjectsByPurposeAndID = (projects) => {
  projects.sort((a, b) => {
    if (a.purpose > b.purpose) {
      return -1;
    }
    if (a.purpose === b.purpose) {
      if (a.id > b.id) return -1;
    } else {
      return 1;
    }
    return 1;
  });
};

export const isUserInsideProjectPath = () => {
  const path = window.location.pathname;
  const regex = new RegExp(/projects\/\d+/);
  if (path.match(regex)) {
    return true;
  }
  return false;
};
